import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/rachat-objets-vide-maison/PageClient.jsx");
